import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { ModalController } from 'ionic-angular';
import { of } from 'rxjs/observable/of';
import { zip } from 'rxjs/observable/zip';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';
import * as actions from './form-manager-page.actions';
import * as fromFormManager from './form-manager-page.reducer';
import { SelectorsFormManager } from './form-manager-page.selectors';

@Injectable()
export class FormManagerPageEffects {

    @Effect({dispatch: false})
    debug$ = this.actions$
        .filter(action => /^\[FormManager\]/.test(action.type))
        .do(action => {
            console.log('FM', action);
        });

    @Effect()
    load$ = this.actions$.ofType(actions.LOAD)
        .switchMap(action => {

            return zip(
                this.appFacade.objects.controlType.store.getAll().take(1),
                this.appFacade.objects.control.store.getAll().take(1),
                this.appFacade.objects.form.store.getAll().take(1),
                this.appFacade.objects.group.store.getAll().take(1),
                this.appFacade.objects.account.store.getActive().take(1),
                this.appFacade.objects.user.store.getActive().take(1),
                this.appFacade.objects.accessGroup.store.getAll().take(1),
                this.appFacade.objects.membership.store.getActive().take(1)
            ).map((
                [
                    controlTypes,
                    controls,
                    forms,
                    groups,
                    account,
                    user,
                    accessGroups,
                    membership
                ]
            ) => {
                return new actions.LoadSuccess({
                    controlTypes,
                    controls,
                    forms,
                    groups,
                    account,
                    user,
                    accessGroups,
                    membership
                });
            }).catch(error => of(new actions.LoadFail(error)));
        });

    @Effect()
    submit$ = this.actions$.ofType(actions.SUBMIT_FORM_MANAGER)
        .switchMap(action => {

            return this.appFacade.store.select(SelectorsFormManager.state)
                .take(1)
                .do((state: fromFormManager.State) => {

                    state.form.deleted.forEach(form => this.appFacade.objects.form.store.remove(form));
                    state.group.deleted.forEach(form => this.appFacade.objects.group.store.remove(form));
                    state.control.deleted.forEach(form => this.appFacade.objects.control.store.remove(form));

                    state.dirtyIds.forms
                        .filter(id => state.form.entities[id])
                        .forEach(id => this.appFacade.objects.form.store.update(state.form.entities[id]));

                    state.dirtyIds.groups
                        .filter(id => state.group.entities[id])
                        .forEach(id => this.appFacade.objects.group.store.update(state.group.entities[id]));

                    state.dirtyIds.controls
                        .filter(id => state.control.entities[id])
                        .forEach(id => this.appFacade.objects.control.store.update(state.control.entities[id]));

                })
                .map(() => new actions.SubmitFormManagerSuccess());
        });

    constructor(
        protected actions$: Actions,
        protected appFacade: VasAppFacade,
        protected modalController: ModalController
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/form-manager-page.effects.ts